import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Layout, Row, Col, Space, Card, Spin} from 'antd';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useEnsureTickersLoaded} from "../../hooks/useEnsureTickersLoaded";
import {useTickerData} from "../../hooks/useTickerData";
import {selectTickerMetadata} from "../../store/slices/globalResources.slice";
import TickerBanner from "./TickerBanner";
import EtfDetails from "./etf/EtfDetails";
import SectorIndustryChart from "../../components/Charts/SectorIndustryChart";
import TradingViewChart from "../../charts/TradingViewChart";
const COMMON_FIELDS = [
    'symbol', 'name', 'logo', 'tags', 'metrics'
];

const ETF_FIELDS = [
    'holdings', 'specs', 'composite.sector_gic', 'composite.industry_gic'
];
const STOCK_FIELDS = [
    'financials'
]

const getFields = (type)=>{
    return [
        ...COMMON_FIELDS,
        ...type==='stock'? STOCK_FIELDS: ETF_FIELDS
    ]
}


const TickerDetails = ({ticker, type})=>{
    return (
        type==='etf'&&<EtfDetails etf={ticker}/>
    )
}

const arrayToObj = (arr)=>{
    const obj = {};
    console.log(arr);
    Array.from(Object.values(arr)).forEach(x=>{
        obj[x.k] = x.v;
    });
    return obj;
}

const TickerView = ()=>{
    const {ticker} = useParams();
    console.log(ticker)
    const { tickers } = useEnsureTickersLoaded([ticker || 'spy']);
    const tickerMetadata = useSelector((state)=>selectTickerMetadata(state, ticker || 'spy'));
    const fields = getFields(tickerMetadata?.type ?? 'etf');
    const tickerData = useTickerData([ticker], fields, 'US');

    console.log(tickerData);
    if (!tickerMetadata?.type || !tickerData?.[ticker]) {
        return (
            <Card>
                <Spin size={'large'}/> Loading {ticker}
            </Card>
        )
    }
    return (
        <Layout>
            <TickerBanner ticker={tickerData?.[ticker]}/>
            <Row>
                <Col flex={'0 0 350px'}>
                    <TickerDetails ticker={tickerData?.[ticker]} type={tickerMetadata?.type}/>
                </Col>
                <Col flex={'auto'}>
                        <Card bordered={false} className={'gapless'}>
                            <TradingViewChart symbol={ticker} />
                        </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    {tickerMetadata.type==='etf' && (
                        <Space direction={'vertical'} style={{maxHeight:400}}>
                            <SectorIndustryChart
                                sectors={arrayToObj(tickerData?.[ticker]?.composite?.sector_gic)}
                                industries={arrayToObj(tickerData?.[ticker]?.composite?.industry_gic)}
                                height={300}
                                width={500}
                                treeChartProps={{
                                    labelSize: 9
                                }}
                            />
                        </Space>
                    )}
                </Col>
            </Row>
        </Layout>
    )


}

export default TickerView;